module.exports = __webpack_public_path__ + "static/img/3.55ad527.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productCenter/3.png
// module id = qbgH
// module chunks = 0